"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldRollup = void 0;
var flApi = require("./flApi");
var RootClass = require("./rootClass");
var FieldRollup = (function (_super) {
    __extends(FieldRollup, _super);
    function FieldRollup(typeObj, jSonDoc, srvType) {
        if (srvType === void 0) { srvType = 1; }
        var _this = this;
        if (typeObj !== "rollup") {
            throw new Error("wrong objectType for a Rollup field");
        }
        _this = _super.call(this, typeObj, jSonDoc, srvType) || this;
        return _this;
    }
    FieldRollup.prototype.encode = function (jSonData) {
        return _super.prototype.encode.call(this, jSonData);
    };
    FieldRollup.prototype.decode = function () {
        return _super.prototype.decode.call(this);
    };
    FieldRollup.prototype.setProp = function (propName, value) {
        return _super.prototype.setProp.call(this, propName, value);
    };
    FieldRollup.prototype.save = function () {
        return _super.prototype.save.call(this, 0);
    };
    FieldRollup.prototype.postProcess = function () {
        _super.prototype.postProcess.call(this);
    };
    FieldRollup.prototype.getData = function () {
        return flApi.Api.getInstance().restApi.getRollupData(this.id, "");
    };
    FieldRollup.prototype.toClass = function () {
        return this;
    };
    return FieldRollup;
}(RootClass.RootClass));
exports.FieldRollup = FieldRollup;
